import React from 'react';
import { Card } from '../ui/Card';
import { Smartphone, TrendingUp, Shield } from 'lucide-react';
const benefits = [{
  icon: Smartphone,
  title: 'Доступ ко всем важным данным через телефон',
  description: 'Управляйте садом из любой точки мира. Вся информация всегда под рукой в удобном мобильном формате.'
}, {
  icon: TrendingUp,
  title: 'Больше финансовой прозрачности',
  description: 'Видите каждый тенге. Автоматические отчеты исключают человеческий фактор и ошибки в расчетах.'
}, {
  icon: Shield,
  title: 'Контроль без постоянного присутствия',
  description: 'Система уведомлений и отчетности позволяет контролировать процессы, не находясь в саду 24/7.'
}];
export function ResultsSection() {
  return <section className="py-20 bg-[#FAFAFA]" id="results" data-id="element-133">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
        <div className="text-center mb-16" data-id="element-135">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A2E] mb-4" data-id="element-136">
            Что меняется после внедрения?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-137">
          {benefits.map((benefit, index) => <div key={index} data-id="element-138">
              <Card className="p-8 h-full text-center" data-id="element-139">
                <div className="w-16 h-16 rounded-2xl bg-[#EDE7F6] text-[#7C4DFF] flex items-center justify-center mx-auto mb-6" data-id="element-140">
                  <benefit.icon size={32} data-id="element-141" />
                </div>
                <h3 className="text-xl font-bold text-[#1A1A2E] mb-4" data-id="element-142">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-143">
                  {benefit.description}
                </p>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}